/** Defines the possible tax rates for expenses etc. */
export enum ExpensesVatRate {
  /** No VAT specified. */
  Undefined = "undefined",
  /** No rate applied (not even 0%).  */
  None = "none",
  /** 25.5% – general VAT rate */
  Tax255 = "tax255",
  /** 24% – general VAT rate */
  Tax24 = "tax24",
   /** 14% – groceries, restaurant services and catering services */
  Tax135 = "tax135",
  /** 13.50% – groceries, restaurant services and catering services */
  Tax14 = "tax14",
  /** 10% VAT rate – Books, culture, passenger transport and accommodation */
  Tax10 = "tax10",
  /** 0% – Zero VAT rate */
  Tax0 = "tax0",
  /** Other VAT rate, manually specified. */
  Other = "other",
  /** Multiple VAT rates: Used in expense report when the expense is split to several rows. */
  Multiple = "multiple",
}